import { render, staticRenderFns } from "./ModalTaskError.vue?vue&type=template&id=27b1d601&scoped=true"
import script from "./ModalTaskError.vue?vue&type=script&lang=js"
export * from "./ModalTaskError.vue?vue&type=script&lang=js"
import style0 from "./ModalTaskError.vue?vue&type=style&index=0&id=27b1d601&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b1d601",
  null
  
)

export default component.exports